import { observer } from 'mobx-react';
import AssignmentHelper from '../../util/AssignmentHelper';
import Button from '@amzn/meridian/button';
import React from 'react';
import UnassignmentController from '../../controllers/UnassignmentController';
import transporterStore from '../../stores/transporterStore';

export interface UnassignCompProps {}

class UnassignComp extends React.Component<UnassignCompProps> {
  constructor(props: UnassignCompProps) {
    super(props);
  }
  render() {
    const selectedIds = AssignmentHelper.getSelectedIds();
    const { selectedTransporterId } = transporterStore;
    return (
      !selectedTransporterId &&
      selectedIds.length > 0 && (
        <Button
          size="medium"
          type="primary"
          onClick={() => UnassignmentController.startUnassignment()}
          propagateClickEvent={false}
        >
          Unassign Selected Order(s)/Route(s)
        </Button>
      )
    );
  }
}

export default observer(UnassignComp);
